// extracted by mini-css-extract-plugin
export default {"langSwitchSelect":"LanguageSwitcher_langSwitchSelect__oZMhY"};